import '@adornis/bh-institution/client/bh-admin-einrichtungen-list.js';
import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { institutionListingPageBuildifyPreset } from '@adornis/buchungsheld-db/_buildify-presets.js';
import { Setting } from '@adornis/buchungsheld-db/entities/settings.js';
import '@adornis/buchungsheld-theme/components/tr-section.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '../components/bh-footer.js';
import '../components/bh-topbar.js';

@customElement('bh-page-landing')
export class BHPageLanding extends BuchungsheldLitElement {
  @state() protected readonly _settings = new RXController(
    this,
    Setting.getGlobalSettings()({
      institutionOverview: 1,
    }),
  );

  override render() {
    const settings = this._settings.value;

    if (!settings) return nothing;

    return html`
      <x-flex ${css({ maxHeight: '100%', overflow: 'auto' })}>
        <bh-topbar></bh-topbar>

        <tr-section h100 ${css({ padding: `${this.spacing.lg} 0` })}>
          ${(() => {
            const buildifyHtml = settings.institutionOverview;
            if (typeof buildifyHtml !== 'string') return unsafeHTML(institutionListingPageBuildifyPreset);
            return unsafeHTML(settings.institutionOverview);
          })()}
        </tr-section>

        <bh-footer></bh-footer>
      </x-flex>
    `;
  }
}
